import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OmnibusInitializationEffects } from './+state/omnibus-initialization.effects';
import { OmniLiveAvailabilityStateModule } from '@cigna/omni/live-availability-state';
import { OmniConversationsStateModule } from '@cigna/omni/conversations-state';

@NgModule({
  imports: [
    StoreModule,
    EffectsModule.forFeature([OmnibusInitializationEffects]),
    OmniLiveAvailabilityStateModule,
    OmniConversationsStateModule,
  ],
  providers: [OmnibusInitializationEffects],
})
export class OmnibusInitializationModule {}
